import React from 'react';

//Third party packages
import { Row, Col, Card } from 'react-bootstrap';
import Skeleton from '../../common/skeleton';

const SearchPageSkeleton = () => (
  <>
    <Row
      className="mt-5 desktop-skeleton"
      role="alert"
      aria-label="fetching data..."
    >
      <Col>
        <Card className="p-2">
          <Skeleton count={1} height={150} />
        </Card>
      </Col>
    </Row>
  </>
);

export default SearchPageSkeleton;
